import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { map, get, isEmpty, toString } from 'lodash';
import { func } from 'prop-types';
import { FlexContainer, Button, FormInput, Row, FormDatePicker, FormSelect } from '../../common';
import { monthOptions } from '../../../utils/misc';

const SpaceBetween = styled.div`
    min-width: ${({ width }) => width};`;

const Filters = ({ handleFilters }) => {
    const [pollName, setPollName] = useState(null);
    const [monthsEvaluate, setMonthsEvaluate] = useState([]);
    const [dateCreate, setDateCreate] = useState([moment().subtract(30, 'days'), moment()]);
    const [status, setStatus] = useState(false);
    const [resetRangeCalendar, setResetRangeCalendar] = useState(false);
    const spaceBetweenWidth = '13px';
    const statusOptions = [{ value: 1, label: 'Activo' }, { value: 2, label: 'Inactivo' }];

    const filters = [
        { name: 'Nombre encuesta', filterFunction: setPollName, type: 'input', value: pollName },
        { name: 'Meses a evaluar', filterFunction: setMonthsEvaluate, type: 'select', value: monthsEvaluate, options: monthOptions, multiple: true },
        { name: 'Fecha de creación', filterFunction: setDateCreate, type: 'date' },
        { name: 'Activo/Inactivo', filterFunction: setStatus, type: 'select', value: status, options: statusOptions }
    ];

    const onSubmit = () => {
        const filters = {
            ...!isEmpty(pollName) && { name_poll: pollName },
            ...!isEmpty(monthsEvaluate) && { months_evaluate: map(monthsEvaluate, ({ value }) => toString(value)) },
            date_create: `${dateCreate[0].format('YYYY-MM-DD')},${dateCreate[1].format('YYYY-MM-DD')}`,
            ...!isEmpty(status) && { status: toString(get(status, 'value')) }
        };

        const formattedFilters = map(filters, (value, key) => {
            return {
                field: key,
                value
            };
        });

        handleFilters(formattedFilters);
    };

    useEffect(() => {
        setResetRangeCalendar(false);
    }, [resetRangeCalendar]);

    const resetFilters = () => {
        setPollName('');
        setMonthsEvaluate([]);
        setDateCreate([moment().subtract(30, 'days'), moment()]);
        setStatus(false);
        setResetRangeCalendar(true);
    };

    return (<FlexContainer padding={23}>
        <Row
            border='1px solid #eaeaea'
            borderRadius={3}
            padding='3px 13px'
            noWrap
            backgroundColor='white'
        >
            {map(filters, ({ name, type, filterFunction, options, value, multiple }) => (
                <>
                    {type === 'input' && <>
                        <FormInput
                            label={name}
                            placeholder='Ingrese nombre'
                            onChange={({ target }) => filterFunction(get(target, 'value'))}
                            value={pollName}
                        />
                        <SpaceBetween width={spaceBetweenWidth} />
                    </>}
                    {type === 'select' && <>
                        <FormSelect
                            multiple={multiple}
                            label={name}
                            options={options}
                            onChange={({ value }) => filterFunction(value)}
                            value={value}
                        />
                        <SpaceBetween width={spaceBetweenWidth} />
                    </>}
                    {type === 'date' && <>
                        {!resetRangeCalendar
                            ? <FormDatePicker
                                range
                                width='100%'
                                label={name}
                                defaultValue={dateCreate}
                                onChange={filterFunction}
                            />
                            : <FormInput label={name} />
                        }
                        <SpaceBetween width={spaceBetweenWidth} />
                    </>}
                </>
            ))}
            <FlexContainer align='flex-end' mB={10}>
                <Button text='Limpiar' onClick={resetFilters} link />
                <SpaceBetween width={spaceBetweenWidth} />
                <Button text='Buscar' onClick={onSubmit} />
            </FlexContainer>
        </Row>
    </FlexContainer>);
};

Filters.propTypes = {
   handleFilters: func
};

export default Filters;
